import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme: any) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  }
}));
